import qs from "qs";
import _ from "lodash";

export function getQueryParams ()
{
	return qs.parse(
		window.location.search.substring(1)
	);
}

export function setQueryParamsInUrl (params)
{
	let url = new URL(window.location);

	_.forEach(_.keys(params), param =>
	{
		const value = params[param];

		(url.searchParams.has(param)
				? url.searchParams.set(param, value)
				: url.searchParams.append(param, value)
		);
	});

	url.search = url.searchParams;
	url = url.toString();

	history.pushState({}, null, url);
}

export function setHash(hash)
{
	const url = (location.pathname + '') + "#" + hash;

	history.pushState({}, null, url);
}

export function removeQueryParamsFromUrl ()
{
	window.history.replaceState({}, document.title, window.location.pathname);
}
